// Fire the sales/marketing lead to the team's Google Form. Ported from
// landing/components/marketing/googleFormSubmit.ts. Fire-and-forget with
// `mode: 'no-cors'` — the opaque response can't be inspected, so we treat a
// resolved fetch as success and any throw as failure. Never sends a password
// (ContactFormValues has no password field).

import {
  ContactFormValues, GOOGLE_FORM_FIELD_MAPPING, GOOGLE_FORM_ACTION_URL, pageHistoryFor,
} from './fieldMapping';

export async function submitToGoogleForm(values: ContactFormValues): Promise<boolean> {
  try {
    const formData = new URLSearchParams();

    (Object.keys(values) as (keyof ContactFormValues)[]).forEach((fieldKey) => {
      const entryId = GOOGLE_FORM_FIELD_MAPPING[fieldKey];
      const value = values[fieldKey];

      if (entryId && value !== undefined && value !== '') {
        const isIndividual = values.whoAreYou === 'Individual';
        const isOrganization = values.whoAreYou === 'Organization';

        // Only submit fields relevant to the chosen path.
        if (fieldKey.startsWith('org') && !isOrganization) return;
        if (
          (fieldKey === 'individualJobRole' ||
            fieldKey === 'schoolName' ||
            fieldKey === 'stream' ||
            fieldKey === 'yearsOfExperience' ||
            fieldKey === 'codingLanguages') &&
          !isIndividual
        ) {
          return;
        }

        const isStudent = isIndividual && values.individualJobRole === 'Active Student';
        const isDeveloper = isIndividual && values.individualJobRole === 'Developer';
        if ((fieldKey === 'schoolName' || fieldKey === 'stream') && !isStudent) return;
        if ((fieldKey === 'yearsOfExperience' || fieldKey === 'codingLanguages') && !isDeveloper) return;

        formData.append(entryId, String(value));
      }
    });

    // Without pageHistory, Google keeps ONLY page-0 answers (name/email/contact/
    // who-are-you) and silently drops job role, org and student/developer details.
    formData.append('pageHistory', pageHistoryFor(values));
    formData.append('fvv', '1');

    await fetch(GOOGLE_FORM_ACTION_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    return true;
  } catch (error) {
    console.error('Error submitting form to Google Forms:', error);
    return false;
  }
}
